import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';
import { isFuncComp } from '../../../components/common/Helpers/index';

const miniCartDueToday = Loadable(() => (isFuncComp() ? import('../FuncContainers/miniCartDueToday') : import('../containers/miniCartDueToday')));
export default MapTo('vcg/components/soe-home/react/common/miniCartDueToday')(miniCartDueToday);
